import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'showIcon', 'hideIcon'];

  toggle() {
    if (this.inputTarget.type === 'password') {
      this.inputTarget.type = 'text';
    } else {
      this.inputTarget.type = 'password';
    }

    this.showIconTarget.classList.toggle('d-none');
    this.hideIconTarget.classList.toggle('d-none');
  }
}
